"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAsyncReportRequestToJSON = exports.CreateAsyncReportRequestFromJSONTyped = exports.CreateAsyncReportRequestFromJSON = exports.instanceOfCreateAsyncReportRequest = void 0;
var runtime_1 = require("../runtime");
var AsyncReportDimension_1 = require("./AsyncReportDimension");
var AsyncReportEntityStatus_1 = require("./AsyncReportEntityStatus");
var AsyncReportGranularity_1 = require("./AsyncReportGranularity");
var AsyncReportMetric_1 = require("./AsyncReportMetric");
/**
 * Check if a given object implements the CreateAsyncReportRequest interface.
 */
function instanceOfCreateAsyncReportRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "granularity" in value;
    isInstance = isInstance && "dimensions" in value;
    isInstance = isInstance && "metrics" in value;
    return isInstance;
}
exports.instanceOfCreateAsyncReportRequest = instanceOfCreateAsyncReportRequest;
function CreateAsyncReportRequestFromJSON(json) {
    return CreateAsyncReportRequestFromJSONTyped(json, false);
}
exports.CreateAsyncReportRequestFromJSON = CreateAsyncReportRequestFromJSON;
function CreateAsyncReportRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'granularity': (0, AsyncReportGranularity_1.AsyncReportGranularityFromJSON)(json['granularity']),
        'dimensions': (json['dimensions'].map(AsyncReportDimension_1.AsyncReportDimensionFromJSON)),
        'metrics': (json['metrics'].map(AsyncReportMetric_1.AsyncReportMetricFromJSON)),
        'statuses': !(0, runtime_1.exists)(json, 'statuses') ? undefined : (json['statuses'].map(AsyncReportEntityStatus_1.AsyncReportEntityStatusFromJSON)),
        'campaignIds': !(0, runtime_1.exists)(json, 'campaign_ids') ? undefined : json['campaign_ids'],
        'reportStart': !(0, runtime_1.exists)(json, 'report_start') ? undefined : (new Date(json['report_start'])),
        'reportEnd': !(0, runtime_1.exists)(json, 'report_end') ? undefined : (new Date(json['report_end'])),
    };
}
exports.CreateAsyncReportRequestFromJSONTyped = CreateAsyncReportRequestFromJSONTyped;
function CreateAsyncReportRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'granularity': (0, AsyncReportGranularity_1.AsyncReportGranularityToJSON)(value.granularity),
        'dimensions': (value.dimensions.map(AsyncReportDimension_1.AsyncReportDimensionToJSON)),
        'metrics': (value.metrics.map(AsyncReportMetric_1.AsyncReportMetricToJSON)),
        'statuses': value.statuses === undefined ? undefined : (value.statuses.map(AsyncReportEntityStatus_1.AsyncReportEntityStatusToJSON)),
        'campaign_ids': value.campaignIds,
        'report_start': value.reportStart === undefined ? undefined : (value.reportStart.toISOString()),
        'report_end': value.reportEnd === undefined ? undefined : (value.reportEnd.toISOString()),
    };
}
exports.CreateAsyncReportRequestToJSON = CreateAsyncReportRequestToJSON;
